export const createDefaultNumber = (index) => `Новый стол - ${index + 1}`;
